import { Button, makeStyles } from "@material-ui/core";
import React from "react";
import { SaveButton, Toolbar, usePermissions, useRedirect, useTranslate } from "react-admin";
import { useFormState } from "react-final-form";

import { MuiButtonMainProps } from "components/_helpers/props/MuiButtonProps";
import { isInArray } from "utils/general";
import { AllowedEditStatus } from "entities/DeviationStatus";
// import { UserRole } from '../../entities';

const useStyles = makeStyles((theme) => ({
	button: {
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
	},
	toolbar: {
		display: "flex",
		justifyContent: "space-around",
		alignContent: "center",
	},
}));


export const DeviationWizardToolbar = ({
	activeStep,
	setActiveStep,
	stepsLength,
	canMoveForward,
	isNextDisabled,
	nextCallback,
	save,
	saveDisabled,
	handleSubmitWithRedirect,
	...props
}) => {
	// const { permissions } = usePermissions();
	const classes = useStyles();
	const redirect = useRedirect();
	const translate = useTranslate();
	const { values } = useFormState();
	const handleBack = () => {
		setActiveStep((prevStep) => prevStep - 1);
	};
	const handleNext = () => {
		nextCallback && nextCallback();
		if (canMoveForward) setActiveStep((prevStep) => prevStep + 1);
	};

	const isLastStep = activeStep === stepsLength - 1;

	const isSubmitBtnEnable = !props.record.status || isInArray(AllowedEditStatus, props.record.status);

	return (
		<Toolbar className={classes.toolbar} {...props}>
			<Button
				{...MuiButtonMainProps}
				disabled={activeStep == 0}
				className={classes.button}
				onClick={handleBack}
			>
				{translate("osfc.buttons.back")}
			</Button>
			<div>
				<Button
					{...MuiButtonMainProps}
					className={classes.button}
					onClick={() => redirect(props.basePath)}
				>
					{translate("osfc.buttons.cancel")}
				</Button>
				<SaveButton
					label={Number.isInteger(values.action) ? translate("osfc.buttons.finish") : undefined}
					disabled={!isSubmitBtnEnable || saveDisabled}
					handleSubmitWithRedirect={handleSubmitWithRedirect}
				/>
			</div>
			<Button
				{...MuiButtonMainProps}
				className={classes.button}
				disabled={isNextDisabled || isLastStep}
				onClick={handleNext}
			>
				{translate("osfc.buttons.next")}
			</Button>
		</Toolbar>
	);
};
